<template>
  <div class="address-bar">
    <div class="container bar-content">
      <div class="phase-interact">
        <transition name="change-text" mode="out-in">
          <div @click="$emit('goBack')" class="back-button" v-if="showBackButton">
            <icon icon="arrow-left-long-solid" size="sm"></icon>
            <span class="label"> Terug </span>
          </div>
        </transition>
        <transition name="change-text" mode="out-in">
          <h1 :key="label">{{ label }}</h1>
        </transition>
      </div>

      <transition name="change-label" mode="out-in">
        <span class="secure-label" v-if="secure">
          <span> Beveiligd</span>
          <icon icon="x-fa-lock" size="sm"></icon>
        </span>
      </transition>
    </div>
  </div>
</template>

<script>
import Icon from '../../../vue-elements/icon/Icon.vue';

export default {
  components: { Icon },
  props: {
    label: String,
    secure: Boolean,
    showBackButton: true,
  },
};
</script>

<style lang="scss" scoped>
@use "assets/scss/_helpers/display";
@use "assets/scss/_variables/colors";
@use "assets/scss/_helpers/breakpoint";

.change-label-leave-active,
.change-label-enter-active,
.change-text-enter-active,
.change-text-leave-active {
  transition-property: opacity;
  transition-duration: 0.4s;
  transition-timing-function: ease;
}

.change-label-enter-active {
  transition-delay: 0.4s;
}

.change-label-enter,
.change-label-leave-to,
.change-text-enter,
.change-text-leave-to {
  opacity: 0;
}

.address-bar {
  padding: 12px 16px;
  background: colors.$block-blue-100;
  color: #fff;

  @include breakpoint.up(md) {
    padding: 24px;
  }

  .bar-content {
    @include display.flex-row-between();
    padding-left: 0;
    padding-right: 0;

    @include breakpoint.up(md) {
      @include display.flex-row-start();

      padding-left: inherit;
      padding-right: inherit;
    }
  }

  .phase-interact {
    @include display.flex-row-between();
  }

  .back-button {
    @include display.flex-row-start();

    padding-right: 16px;
    border-right: 1px solid #fff;
    margin-right: 16px;
    cursor: pointer;

    .icon-element {
      background-color: #fff;
      margin-right: 10px;
    }
  }

  .label {
    @include breakpoint.down(md) {
      display: none;
    }
  }

  h1 {
    margin: 0;
    font-size: 16px;
    line-height: 22px;
    text-align: left;
    @include breakpoint.up(lg) {
      font-size: 32px;
      line-height: 42px;
    }
  }

  .secure-label {
    @include display.flex-row-between;

    padding: 4px 8px;
    border-radius: 5px;
    background-color: colors.$link-base-default;
    color: colors.$text-light;
    margin-left: 16px;
    line-height: 1.4rem;
    font-size: 14px;

    @include breakpoint.up(md) {
      padding: 8px 12px;
      line-height: 1.6rem;
      font-size: 16px;
    }

    .icon-element {
      background-color: colors.$text-light;
      margin-left: 8px;
    }
  }
}
</style>
